import { AppEnvironment } from "../constants/Global";

export const setStorage = (key, value) => {
    localStorage.setItem(AppEnvironment.AppPrefix + key, value);
};

export const getStorage = (key) => {
    return localStorage.getItem(AppEnvironment.AppPrefix + key);
};

export const killSession = () => {
    localStorage.clear();
};